import React from 'react';
import { ProfileImage } from 'components/ProfileImage';
import { PrimaryButtonLink, SecondaryButton, PrimaryButton } from 'styleguide/Buttons';
import { H5, P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { Spacing } from 'styleguide/spacing';
import { RoutineDetailViewModel } from '../RoutineDetailViewModel';
import { Link } from 'components/Link';
import { FlexRow } from 'styleguide/Row';
import { observer } from 'mobx-react-lite';
import { t } from 'translations/t';

export const RoutineOwnerContent = observer(({ vm }: { vm: RoutineDetailViewModel }) => {
  return (
    <View>
      <View style={{ marginBottom: Spacing.lg }}>
        <Link href={`/user/${vm.username}`}>
          <FlexRow style={{ gap: Spacing.md }}>
            <ProfileImage diameter={64} source={vm.routineOwnerProfilePic} />
            <View>
              <P2 type="secondary">{t('web.folderDetail.createdBy')}</P2>
              <H5>{vm.username}</H5>
            </View>
          </FlexRow>
        </Link>
      </View>

      {vm.isAuthenticated &&
        (vm.isUsersRoutine ? (
          <PrimaryButtonLink
            title={t('web.routineDetail.editRoutine')}
            style={{ marginBottom: Spacing.sm }}
            to={`/edit-routine/${vm.routineId}`}
          />
        ) : (
          <View>
            {vm.isRoutineSaved ? (
              <SecondaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onExistingUserSaveRoutine}
              />
            ) : (
              <PrimaryButton
                title={vm.existingUserSaveButtonTitle}
                style={{ marginBottom: Spacing.sm }}
                onClick={vm.onExistingUserSaveRoutine}
              />
            )}
          </View>
        ))}

      <SecondaryButton
        title={t('web.routineDetail.copyRoutineLink')}
        onClick={vm.onCopyUrl}
        iconType={'link'}
      />
    </View>
  );
});
